import { Box, Grid, Skeleton } from '@mui/material'
import React from 'react'

const WalletFlowSkeleton = () => {
    return (
        <Grid container spacing={2} sx={{ paddingTop: "1rem", width: '100%' }}>
            <Grid
                xs={12}
                sx={{
                    background: '#fff',
                    height: '150px',
                    display: 'flex',
                    alignItems: 'center',
                    paddingInline: "40px"
                }}
            >
                <Skeleton width={"100%"} height={125} sx={{ transform: "unset" }} />
            </Grid>
            <Grid
                xs={12}
                sx={{
                    paddingX: '1em',
                    height: "1000px",
                    paddingTop: "18px"
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {[...Array(3)].map((_, index) => (
                        <Skeleton width={"100%"} height={100} sx={{ transform: "unset" }} key={index} />
                    ))}
                </Box>
            </Grid>
        </Grid >
    )
}

export default WalletFlowSkeleton